import React from 'react';
import {
    List,
    Edit,
    Create,
    Datagrid,
    TextField,
    EditButton,
    SimpleForm,
    TextInput,
    SelectField,
    SelectInput,
    NumberInput,
} from 'react-admin';

import { required, maxLength, minLength } from './../../utils/validations';

const choices = [
    { id: true, name: 'Yes' },
    { id: false, name: 'No' }
];

export const DeliveryAreaList = (props) => (
    <List {...props} title="Delivery Areas" bulkActionButtons={false}>
        <Datagrid>
            <TextField source="name" label="Name" {...props} />
            <TextField source="description" label="Description" />
            <TextField source="latitude" label="Latitude" />
            <TextField source="longitude" label="Longitude" />
            <SelectField
                label="Enabled"
                source="enabled"
                choices={choices} />
            <EditButton />
        </Datagrid>
    </List>
);

const DeliveryAreaTitle = ({ record }) => {
    return <span>Delivery-Area {record ? `"${record.name}"` : ''}</span>;
};

const validateName = [required(), minLength(2), maxLength(60)];

export const DeliveryAreaEdit = (props) => (
    <Edit title={<DeliveryAreaTitle />} {...props} redirect="list" actions={null}>
        {createUpdateForm}
    </Edit>
);

const createUpdateForm = <SimpleForm redirect="list">
    <TextInput label="Name" source="name" validate={validateName} />
    <TextInput label="Description" source="description" validate={required()} />
    <NumberInput
        label="Latitude"
        source="latitude"
        validate={required()}
        defaultValue={0} />

    <NumberInput
        label="Longitude"
        source="longitude"
        validate={required()}
        defaultValue={0} />

    <SelectInput
        label="Enabled"
        source="enabled"
        validate={required()}
        choices={choices} />
</SimpleForm>;

export const DeliveryAreaCreate = (props) => (
    <Create {...props} redirect="list" title="Create Delivery-Area">
        {createUpdateForm}
    </Create>
);

